var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import * as React from 'react';
import { t } from 'i18next';
import { SpecialistCareDetail } from '../../../../../util/care_details/SpecialistCareDetail';
import { BasePartner, } from '../BasePartner';
import { SpecialistCareDetailToDescription } from '../CareDetails';
import { UserContext } from '../../../../../context/UserContext';
import { SourceOfCare } from '../../../../clearstep/proto/results_pb';
import { THEME } from '../../../../clearstep/util/Theme';
import { buildCareCardFromCareOption } from '../../../CareCard/CareCardBuilder';
import { prepareText } from '../../../../clearstep/TextUtil';
import Button from '../../../../tailwind_common/Button';
import { logEvent, MessageType } from '../../../../../util/EventLog';
import '../../../../clearstep/Types';
import PartnerCareLocation from '../../../PartnerCareLocation/PartnerCareLocation';
import '../../../../clearstep/proto/care_locations_pb';
import { isSmallScreen } from '../../../../clearstep/util/AppHelpers';
import { StethoscopeCircleIcon } from '../../../../svg/StethoscopeCircleIcon';
import '../../../CareCard/ButtonContainer/ButtonContainer';
import CareCard from '../../../CareCard/CareCard';
import '../../../../../api/ConversationResults';
import { RegisterCuraiButton } from './RegisterCuraiButton';
import ResultsCard from '../../../ResultsCard/ResultsCard';
import { VirtualVisitCareOptionIcon } from '../../../../svg/VirtualVisitCareOptionIcon';
import { CovidInformationCareDetailDescriptor } from '../../../../../util/care_details/CovidInformationCareDetail';
var specialistCustomizations = (_a = {},
    _a[SpecialistCareDetail.ALLERGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Allergy/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.ANESTHESIOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Anesthesiology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.AUDIOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Audiology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.BARIATRIC_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Weight-and-Wellness-Center/Surgical-Weight-Loss',
            },
        ],
    },
    _a[SpecialistCareDetail.CANCER_CENTER] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Cancer-Center/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CARDIAC_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Cardiac-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CARDIOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Cardiology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CARDIOVASCULAR_CENTER] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Cardiovascular-Center/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CLINICAL_DECISION_MAKING] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Clinical-Decision-Making/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.COLORECTAL_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Colon-and-Rectal-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CONCIERGE_MEDICINE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pratt-Diagnostic-Center/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CLINICAL_NUTRITION] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Nutrition/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.DENTISTRY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Dentistry',
            },
        ],
    },
    _a[SpecialistCareDetail.DEPARTMENT_OF_MEDICINE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Medicine/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.DEPARTMENT_OF_PEDIATRICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pediatrics',
            },
        ],
    },
    _a[SpecialistCareDetail.DEPARTMENT_OF_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.INTERNAL_MEDICINE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Primary-Care/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.GENERAL_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/General-Surgery',
            },
        ],
    },
    _a[SpecialistCareDetail.DERMATOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Dermatology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.EMERGENCY_SERVICES] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Emergency-Services',
            },
        ],
    },
    _a[SpecialistCareDetail.ENT] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Ear-Nose-and-Throat-ENT-Otolaryngology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.ENDOCRINOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Endocrinology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.GAMMA_KNIFE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Neurosurgery/Clinical-Care-Services/Gamma-Knife-Center',
            },
        ],
    },
    _a[SpecialistCareDetail.GASTROENTEROLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Gastroenterology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.GENETICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Genetics-and-Metabolism/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.INFECTIOUS_DISEASE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Infectious-Disease/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.GERIATRICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Geriatrics/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.HEMATOLOGY_ONCOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Hematology-Oncology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.HYPERBARIC_MEDICINE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Vascular-Surgery/Clinical-Care-Services/Vascular-Wound-and-Hyperbaric-Center',
            },
        ],
    },
    _a[SpecialistCareDetail.NEPHROLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Nephrology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.NEUROLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Neurology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.NEUROSURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Neurosurgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.OCCUPATIONAL_THERAPY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Occupational-Therapy',
            },
        ],
    },
    _a[SpecialistCareDetail.GENERAL_ORTHOPEDIC] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthopaedics/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.ORTHOTICS_PROSTHETICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthotics-and-Prosthetics',
            },
        ],
    },
    _a[SpecialistCareDetail.PAIN_MANAGEMENT] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Anesthesiology/Clinical-Care-Services/Pain-Management-Program',
            },
        ],
    },
    _a[SpecialistCareDetail.PALLIATIVE_CARE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Palliative-Care-Services',
            },
        ],
    },
    _a[SpecialistCareDetail.PATHOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pathology-and-Lab-Medicine/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.PEDIATRICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pediatrics',
            },
        ],
    },
    _a[SpecialistCareDetail.PELVIC_FLOOR] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pelvic-Floor-Program',
            },
        ],
    },
    _a[SpecialistCareDetail.PHARMACY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pharmacy',
            },
        ],
    },
    _a[SpecialistCareDetail.PHYSICAL_MEDICINE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Physical-Medicine/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.PHYSICAL_THERAPY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Physical-Therapy',
            },
        ],
    },
    _a[SpecialistCareDetail.PLASTIC_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Plastic-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.RADIOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Radiology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.PSYCHIATRY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Psychiatry/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.PULMONOLOGIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pulmonary/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.RADIATION_ONCOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Radiation-Oncology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.RHEUMATOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Rheumatology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.SPEECH_THERAPY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Speech-Language-Pathology/Speech-Language-Services',
            },
        ],
    },
    _a[SpecialistCareDetail.SPINE_CENTER] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Spine-Center',
            },
        ],
    },
    _a[SpecialistCareDetail.ACUTE_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Surgical-Critical-Care',
            },
        ],
    },
    _a[SpecialistCareDetail.SURGICAL_ONCOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Surgical-Oncology',
            },
        ],
    },
    _a[SpecialistCareDetail.THORACIC_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Thoracic-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.TRANSPLANT_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Transplant-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.TRAUMA_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Trauma-Surgery',
            },
        ],
    },
    _a[SpecialistCareDetail.UROLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Urology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.VASCULAR_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Vascular-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.VOLUNTEER_SERVICES] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Patient-and-Family-Services/Volunteer-Services.aspx',
            },
        ],
    },
    _a[SpecialistCareDetail.WEIGHT_WELLNESS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Weight-and-Wellness-Center/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.WOUND_CARE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/departments-and-services/vascular-surgery/clinical-care-services/vascular-wound-and-hyperbaric-center',
            },
        ],
    },
    _a[SpecialistCareDetail.IMAGING_TEST] = {
        description: 'You can come to the Radiology Department for a variety of imaging services, from the basic to the most complex.',
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Radiology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.OBGYN] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Obstetrics-and-Gynecology/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.OPHTHALMOLOGIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Ophthalmology/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.PODIATRY] = {
        buttons: [
            {
                cta: 'Schedule appointment',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=Podiatry+and+Podiatric+Surgery&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.ANKLE_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=Foot+and+Ankle&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.ELBOW_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=elbow&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.FINGER_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=Hand+Orthopaedics&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.FOOT_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=Foot+and+Ankle&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.FOREARM_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=elbow&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.HAND_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=Hand+Orthopaedics&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.HIP_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=hip&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.KNEE_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=knee&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.SHOULDER_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=shoulder&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.UPPER_ARM_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=shoulder&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.WRIST_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicine.org/find-a-doctor?yext_retrieveFacets=true&yext_sortBys=%5B%7B%22type%22%3A%22RELEVANCE%22%7D%5D&yext_input=Hand+Orthopaedics&yext_offset=0&yext_limit=16&yext_facetFilters=%7B%7D',
            },
        ],
    },
    _a[CovidInformationCareDetailDescriptor.COVID_19_VACCINE_INFORMATION] = {
        title: 'COVID-19 Vaccine Information',
        buttons: [
            {
                cta: 'See more information',
                url: 'https://www.tuftsmedicine.org/for-patients/covid-19-information',
            },
        ],
    },
    _a[CovidInformationCareDetailDescriptor.COVID_19_TESTING_INFORMATION] = {
        title: 'COVID-19 Testing Information',
        buttons: [
            {
                cta: 'See more information',
                url: 'https://www.tuftsmedicine.org/for-patients/covid-19-information',
            },
        ],
    },
    _a);
var TuftsPartner = /** @class */ (function (_super) {
    __extends(TuftsPartner, _super);
    function TuftsPartner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showBookCareNowMessage = function () {
            return !window.location.pathname.includes('/workflows/tufts_login') &&
                !window.location.pathname.includes('/workflows/tufts_telemedicine');
        };
        return _this;
    }
    TuftsPartner.prototype.addButton = function (careCard, buttonName, buttonUrl) {
        var newButton = {
            cta: buttonName,
            url: buttonUrl,
        };
        var buttons = careCard.buttons;
        if (careCard) {
            if (buttons) {
                var hasButton = buttons.some(function (button) { return button.cta === buttonName; });
                if (hasButton) {
                    return buttons;
                }
                return __spreadArray([newButton], buttons, true);
            }
        }
        return [newButton];
    };
    TuftsPartner.prototype.schedulingLinkConfig = function (location) {
        var careType = location.careType;
        var schedulingLink = location.schedulingLink;
        if (!schedulingLink) {
            return null;
        }
        var buttonText = careType === SourceOfCare.Type.PRIMARY_CARE
            ? 'View Profile'
            : careType === SourceOfCare.Type.URGENT_CARE
                ? 'Schedule at Location'
                : 'Book Now!';
        if (careType === SourceOfCare.Type.URGENT_CARE) {
            schedulingLink = undefined;
        }
        var openInNewTab = function (newUrl) {
            window.open(newUrl, '_blank', 'noopener,noreferrer');
        };
        return {
            schedulingLinkImg: (React.createElement(Button, { alternative: true, onClick: function () {
                    logEvent(MessageType.CLICKED_PARTNER_CARE_OPTION, { data: { text: buttonText } }, { partner: THEME.partner });
                    if (schedulingLink) {
                        openInNewTab(schedulingLink);
                    }
                } }, buttonText)),
            schedulingLink: schedulingLink || '',
        };
    };
    TuftsPartner.prototype.showCareOptionDescription = function (options) {
        switch (options.careType) {
            default:
                return false;
        }
    };
    TuftsPartner.prototype.primaryCareOption = function (options) {
        var careLocations = options === null || options === void 0 ? void 0 : options.careLocations;
        var numberOfCareLocations = options === null || options === void 0 ? void 0 : options.numberOfCareLocations;
        return TuftsPartner.careOptionsWithLocations(options, careLocations, numberOfCareLocations, true);
    };
    TuftsPartner.prototype.urgentCareOption = function (options) {
        var careLocations = options === null || options === void 0 ? void 0 : options.careLocations;
        var numberOfCareLocations = options === null || options === void 0 ? void 0 : options.numberOfCareLocations;
        return TuftsPartner.careOptionsWithLocations(options, careLocations, numberOfCareLocations, false);
    };
    TuftsPartner.careOptionsWithLocations = function (options, careLocations, numberOfCareLocations, includePhysicianImage) {
        if (options) {
            return (React.createElement("div", null,
                buildCareCardFromCareOption(options, undefined, Array.isArray(careLocations) && !!careLocations.length),
                React.createElement("br", null),
                React.createElement("br", null),
                Array.isArray(careLocations) &&
                    !!careLocations.length &&
                    careLocations
                        .slice(0, numberOfCareLocations !== null && numberOfCareLocations !== void 0 ? numberOfCareLocations : 5)
                        .map(function (careLocation) { return (React.createElement(PartnerCareLocation, { location: careLocation, key: careLocation.name, includePhysicianImage: includePhysicianImage, defaultImageIcon: "/static/images/partners/tufts/img-physician-placeholder.png", ctaForName: true, showDefaultLocationHours: false })); })));
        }
        return null;
    };
    TuftsPartner.prototype.getERCardCustomizations = function () {
        return {
            description: 'The emergency department has people and equipment to take care of severe, high risk, and life-threatening problems 24 hours a day. No appointment is needed.',
            icon: React.createElement(StethoscopeCircleIcon, null),
        };
    };
    TuftsPartner.prototype.partnerOptionWithCareDetail = function (options) {
        var _a, _b;
        var isProxyUser = React.useContext(UserContext).isProxyUser;
        // Remove eligibility tag from details. If exists, mark isEligibility so a disclaimer is not added
        if (!options.careDetails) {
            return null;
        }
        var partnerCareDetails = options.careDetails.map(function (detail) {
            var detailArray = detail.split('_');
            return detailArray[0];
        });
        var firstDetail = partnerCareDetails.find(function (detail) { return detail in specialistCustomizations; });
        if (!firstDetail) {
            return null;
        }
        var mapDescription = (_a = SpecialistCareDetailToDescription[firstDetail]) !== null && _a !== void 0 ? _a : '';
        var card = specialistCustomizations[firstDetail];
        var cardDescription = card.description, title = card.title;
        var specialistDescription = (_b = SpecialistCareDetailToDescription[firstDetail]) !== null && _b !== void 0 ? _b : prepareText("".concat(mapDescription, " You may need a referral from your primary care provider depending on your insurance. Enter your zip code above to find a provider. If no providers are available, please visit the Tufts website below for more information"), { isProxyUser: isProxyUser });
        var description = cardDescription !== null && cardDescription !== void 0 ? cardDescription : specialistDescription; // Override standard mapping with per partner description if exists
        return TuftsPartner.careOptionsWithLocations({
            subtitle: title,
            description: description,
            buttons: card.buttons,
        }, // Dirty, but No real need to create a new SpecialistCareOptionProps type
        options.careLocations, 10, // TODO: use numberOfCareLocations from options
        true);
    };
    TuftsPartner.prototype.virtualVisitOptions = function (options) {
        if (options.sourceOfCare) {
            return (React.createElement(React.Fragment, null,
                buildCareCardFromCareOption(options.sourceOfCare, undefined, false),
                React.createElement(RegisterCuraiButton, null)));
        }
        return null;
    };
    TuftsPartner.prototype.searchCareLocationDefaults = function (_triageResponse) {
        return {
            sort: 'soonest_availability',
            findNextAvailableSlot: false,
        };
    };
    TuftsPartner.prototype.covidDoctorTriageResponse = function (options) {
        if (options.hasTelemedicineSupport) {
            return (React.createElement(ResultsCard, { useDropdownRenderStyling: true },
                React.createElement("h2", null, t('common.findCareNearYou', 'Find care near you')),
                buildCareCardFromCareOption({
                    description: '',
                    isMarkdown: true,
                    heading: 'p',
                    buttons: [
                        {
                            clickEventName: '',
                            heading: 'h3',
                            text: '',
                            url: 'https://tuftshealthplan.com/member/employer-individual-or-family-plans/tools-resources/digital-tools/telehealth',
                            cta: 'See Telehealth options',
                            hasMarginTop: false,
                            useWhitespace: false,
                        },
                    ],
                    subtitle: 'A virtual visit with a doctor (often referred to as telemedicine or telehealth) is a convenient and affordable alternative to an in-person visit. A primary care doctor evaluates you in a video chat window, and may refer you to a specialist for additional care, if appropriate. Enter your zip code above to find a telehealth provider',
                })));
        }
        return this.covidDoctorTriageOptions(options);
    };
    TuftsPartner.prototype.showZipcodeInput = function (careOptions) {
        if (careOptions && careOptions.length > 0) {
            return !careOptions.every(function (careOption) { return careOption.careType === SourceOfCare.Type.TELEMEDICINE; });
        }
        return true;
    };
    TuftsPartner.prototype.covidDoctorTriageOptions = function (options) {
        var heightAndWidthSize = isSmallScreen() ? '28' : '56';
        return (React.createElement(ResultsCard, null,
            React.createElement("h2", null, t('common.findCareNearYou', 'Find care near you')),
            React.createElement(React.Fragment, null,
                options.hasTestingSupport && (React.createElement(CareCard, { title: t('basePartner.covidDoctorTriage.doctorCareCard.title', 'Speak with a doctor'), icon: React.createElement(VirtualVisitCareOptionIcon, { height: heightAndWidthSize, width: heightAndWidthSize }) })),
                options.hasTestingSupport && options.isTestToTreat && (React.createElement(CareCard, { useMarginTop: true, buttons: [
                        {
                            url: 'https://covid-19-test-to-treat-locator-dhhs.hub.arcgis.com/',
                            cta: t('basePartner.covidDoctorTriage.getTestedCareCard.cta', 'Get tested and treated for COVID-19 at a pharmacy near you'),
                        },
                    ] })))));
    };
    return TuftsPartner;
}(BasePartner));
export { TuftsPartner };
